import { combineReducers } from "redux";

const teacherFromStorage = JSON.parse(localStorage.getItem("teacher"));
const themeFromStorage = localStorage.getItem("theme");

function teacher(state = teacherFromStorage, action) {
  switch (action.type) {
    case "SAVE_TEACHER":
      return action.teacher;
    case "CLEAR_TEACHER":
      return null;
    default:
      return state;
  }
}

function theme(state = themeFromStorage, action) {
  switch (action.type) {
    case "CHANGE_THEME":
      return action.theme;
    default:
      return state;
  }
}

const visioApp = combineReducers({ teacher, theme });

export default visioApp;
